export default "__VITE_ASSET__b552f9d4__"